import * as React from 'react';

import { Bold } from 'Icons/WYSIWYG';
import { IconProps } from '../IconProps';
import { SVGWrapper } from '../SVGWrapper';

export const NounIconUpload: React.FC<IconProps> = ({ aspect, color, style = {} }) => (
    <SVGWrapper aspect={aspect} color={color} style={style} viewBox="45 30 64 64" fill="none">
        <g>
            <path
                d="M52 86.2205V41.2817C52 40.1466 52.4509 39.058 53.2536 38.2554C54.0562 37.4527 55.1448 37.0018 56.2799 37.0018H72.0727C73.0504 36.9733 74.0083 37.2806 74.787 37.8724C75.5657 38.4642 76.1182 39.3049 76.3526 40.2545L77.6793 45.5616H103.359C104.494 45.5616 105.582 46.0125 106.385 46.8151C107.188 47.6178 107.639 48.7064 107.639 49.8415V86.2205C107.639 87.3556 107.188 88.4442 106.385 89.2469C105.582 90.0495 104.494 90.5004 103.359 90.5004H56.2799C55.1448 90.5004 54.0562 90.0495 53.2536 89.2469C52.4509 88.4442 52 87.3556 52 86.2205Z"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M69.1196 72.3109L75.5394 76.5908L88.3791 59.4712"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </SVGWrapper>
);
